import FieldTypesEnum from '../Enums/FieldTypesEnum';
import mathHelper from '../Helpers/mathHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import React from 'react';
import PlanningProgressGraph from '../Elements/PlanningProgressGraph';
import statusHelper from '../Helpers/statusHelper';
import stringHelper from '../Helpers/stringHelper';
import userHelper from '../Helpers/userHelper';
import PlanningStatusEnum from '../Enums/PlanningStatusEnum';
import PlanningCancellationDecisionOptionsArray from '../Enums/PlanningCancellationDecisionOptionsArray';
import ShownSubPanelsEnum from '../Enums/ShownSubPanelsEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
// Same import cycle PlanningItem.js already has (Domain -> PlanningDetailList -> Domain); safe because it is
// only dereferenced inside a static method at render time, never at module load.
import Link from '../Elements/link';
import PlanningDetailList from '../Contents/Planning/PlanningDetail/PlanningDetailList';
import UserNameComponent from '../Elements/UserNameComponent';
import PlanningDetailSnapshotInlineSummary from '../Contents/Planning/PlanningDetailSnapshot/PlanningDetailSnapshotInlineSummary.jsx';
import PlannedCell from '../Contents/Planning/PlanningDetail/PlannedCell';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';

export default class PlanningDetailsItem {
  constructor(item) {
    this.PlanningDetailId = item.planningDetailId;
    this.PricingId = item.pricingId;
    this.PricingDetailId = item.pricingDetailId;
    this.OpportunityId = item.opportunityId;
    this.CreatedOn = item.createdOn;
    this.FieldworkOrderNumber = item.fieldworkOrderNumber;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.NumberOfPlannedAssignments = item.numberOfPlannedAssignments;
    this.NumberOfContractedAssignments = item.numberOfContractedAssignments;
    this.NumberOfContractedAssignmentsOriginal = item.numberOfContractedAssignmentsOriginal;
    this.OwningOfficeRevenueContracted = item.owningOfficeRevenueContracted;
    this.FieldworkOfficeRevenueContracted = item.fieldworkOfficeRevenueContracted;
    this.FieldworkOfficeCurrency = item.fieldWorkOfficeCurrency;
    this.OwningOfficeCurrency = item.owningOfficeCurrency;
    this.ClientName = item.clientName;
    this.OpportunityName = item.opportunityName;
    this.ServiceName = item.serviceName;
    this.PricingDetailName = item.pricingDetailName;
    this.OpportunityStatuscode = item.opportunityStatuscode;
    this.PlanningDetailStatusCompleted = item.planningDetailStatusCompleted;
    this.CountryId = item.countryId;
    this.CountryName = item.countryName;
    this.ServiceId = item.serviceId;
    this.ClientId = item.clientId;
    this.ClientOwner = item.clientOwner;
    this.SchedulerUserId = item.schedulerUserId;
    this.EvalBonusPerCycle = item.evalBonusPerCycle;
    this.Status = item.status;
    this.ReplacedByPricingId = item.replacedByPricingId;
    const cancellationDecisionOption = PlanningCancellationDecisionOptionsArray.find(
      (option) => option.value === item.cancellationDecision
    );
    this.CancellationDecision = cancellationDecisionOption ? cancellationDecisionOption.label : '';
    this.CancellationComment = item.cancellationComment;
    this.TargetAssignmentRate1 = item.targetAssignmentRate1;
    this.TargetAssignmentRate2 = item.targetAssignmentRate2;
    this.TargetAssignmentRate3 = item.targetAssignmentRate3;
    this.TargetAssignmentRate4 = item.targetAssignmentRate4;
    this.TargetCompletionRate1 = item.targetCompletionRate1;
    this.TargetCompletionRate2 = item.targetCompletionRate2;
    this.TargetCompletionRate3 = item.targetCompletionRate3;
    this.TargetCompletionRate4 = item.targetCompletionRate4;

    this.IsDateLocked = item.isDateLocked;
    this.RolledInVolume = item.rolledInVolume || 0;
    this.RolledOutVolume = item.rolledOutVolume || 0;
    this.ExtendedEndDate = item.extendedEndDate;
    this.TpRunId = item.tpRunId;
    this.WaveId = item.waveId;
    this.TpRunDisplayName = item.tpRunDisplayName;
    this.WaveName = item.waveName;
    this.MysteryShoppingPlatformPricingId = item.mysteryShoppingPlatformPricingId;

    this.NumberOfAssignmentsAll = item.numberOfAssignmentsAll; //Number of Assigned Assignments
    this.NumberOfAssignmentsSelfAssigned = item.numberOfAssignmentsSelfAssigned;
    this.NumberOfAssignmentsCompleted = item.numberOfAssignmentsCompleted;
    this.NumberOfAssignmentsFinalized = item.numberOfAssignmentsFinalized;
    this.NumberOfAssignmentsExcluded = item.numberOfAssignmentsExcluded;
    this.NumberOfAssignmentsInvoiced = item.numberOfAssignmentsInvoiced;
    this.NumberOfAssignmentsExcludedEx = item.numberOfAssignmentsExcludedEx;
    this.NumberOfAssignmentsExcludedPS = item.numberOfAssignmentsExcludedPS;
    this.NumberOfAssignmentsExcludedBC = item.numberOfAssignmentsExcludedBC;
    this.OfficeName = item.officeName;
    this.PricingOwningOfficeFeePerEval = item.pricingOwningOfficeFeePerEval;
    this.PricingFieldworkOfficeFeePerEval = item.pricingFieldworkOfficeFeePerEval;
    this.EvalFeePerEval = item.evalFeePerEval;
    this.PricingDetailEditorCostPerEval = item.pricingDetailEditorCostPerEval;
    this.ActualEvaluatorFee = item.actualEvaluatorFee;
    this.ActualEvaluatorFeePerAssignment = item.actualEvaluatorFeePerAssignment;

    this.TotalContractedFeeAmount = this.EvalFeePerEval * this.NumberOfContractedAssignments;
    this.TotalPlannedFeeAmount = this.EvalFeePerEval * this.NumberOfPlannedAssignments;

    this.TotalPlannedBonusAmount =
      (this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfPlannedAssignments;
    this.PercentageOfContractedEvaluatorFee = mathHelper.PercentageText(
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments,
      this.PricingFieldworkOfficeFeePerEval
    );
    this.PlannedShopperFeePerAssignedAssignments =
      (this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfAssignmentsAll;

    this.TotalContractedEvaluatorFeePlusBonus = this.TotalContractedFeeAmount + this.EvalBonusPerCycle;
    this.TotalContractedEvaluatorFeePerAssignmentInclBonus =
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments;
    this.TotalPlannedEvaluatorFeePlusBonus = this.TotalPlannedFeeAmount + this.TotalPlannedBonusAmount;
    this.TotalPlannedEvaluatorFeePerAssignment =
      this.NumberOfPlannedAssignments === 0
        ? 0
        : this.EvalFeePerEval + this.TotalPlannedBonusAmount / this.NumberOfPlannedAssignments;

    this.PlannedRevenueOwningOffice = this.NumberOfPlannedAssignments * this.PricingOwningOfficeFeePerEval;
    this.InvoicedRevenueOwningOffice = this.NumberOfAssignmentsInvoiced * this.PricingOwningOfficeFeePerEval;
    this.PlannedRevenueFieldworkOffice = this.NumberOfPlannedAssignments * this.PricingFieldworkOfficeFeePerEval;
    this.InvoicedRevenueFieldworkOffice = this.NumberOfAssignmentsInvoiced * this.PricingFieldworkOfficeFeePerEval;

    this.PercentageOfActualEvaluatorFee = mathHelper.PercentageText(
      this.ActualEvaluatorFeePerAssignment,
      this.PricingFieldworkOfficeFeePerEval
    );

    this.PercentageOfAssignedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsAll,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfCompletedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsCompleted,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfFinalizedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsFinalized,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfExcludedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsExcluded,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfInvoicedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsInvoiced,
      this.NumberOfContractedAssignments
    );
    this.PercentageOfSelfAssignedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsSelfAssigned,
      this.NumberOfContractedAssignments
    );

    this.Selected = true;
  }

  static IsThisFieldEditable(fieldname) {
    return ['StartDate', 'EndDate', 'NumberOfPlannedAssignments'].includes(fieldname);
  }

  static IsThisFieldADate(fieldname) {
    this.DateFields().includes(fieldname);
  }

  static DateFields = ['CreatedOn', 'StartDate', 'EndDate', 'ExtendedEndDate'];

  static DateOnlyFields = ['StartDate', 'EndDate', 'ExtendedEndDate'];

  static ConvertEditedDataToPlanningDetailsItem(editedData) {
    const item = {};
    item.planningDetailId = editedData.PlanningDetailId;
    item.pricingId = editedData.PricingId;
    item.pricingDetailId = editedData.PricingDetailId;
    item.opportunityId = editedData.OpportunityId;
    item.createdOn = editedData.CreatedOn;
    item.fieldworkOrderNumber = editedData.FieldworkOrderNumber;
    item.startDate = editedData.StartDate;
    item.endDate = editedData.EndDate;
    item.isDateLocked = editedData.IsDateLocked;
    item.extendedEndDate = editedData.ExtendedEndDate;
    item.tpRunId = editedData.TpRunId;
    item.waveId = editedData.WaveId;
    item.tpRunDisplayName = editedData.TpRunDisplayName;
    item.waveName = editedData.WaveName;
    item.numberOfPlannedAssignments = parseInt(editedData.NumberOfPlannedAssignments);
    item.numberOfContractedAssignments = editedData.NumberOfContractedAssignments;
    item.revenueContracted = editedData.RevenueContracted;
    item.currencyCode = editedData.CurrencyCode;
    item.clientName = editedData.ClientName;
    item.opportunityName = editedData.OpportunityName;
    item.serviceName = editedData.ServiceName;
    item.pricingDetailName = editedData.PricingDetailName;
    item.opportunityStatuscode = editedData.OpportunityStatuscode;
    item.planningDetailStatusCompleted = editedData.PlanningDetailStatusCompleted;
    item.countryId = editedData.CountryId;
    item.countryName = editedData.CountryName;
    item.serviceId = editedData.ServiceId;
    item.clientId = editedData.ClientId;
    item.numberOfAssignmentsAll = editedData.NumberOfAssignmentsAll;
    item.numberOfAssignmentsCompleted = editedData.NumberOfAssignmentsCompleted;
    item.numberOfAssignmentsFinalized = editedData.NumberOfAssignmentsFinalized;
    item.numberOfAssignmentsExcluded = editedData.NumberOfAssignmentsExcluded;
    item.numberOfAssignmentsInvoiced = editedData.NumberOfAssignmentsInvoiced;
    item.evalBonusPerCycle = editedData.EvalBonusPerCycle;

    return new PlanningDetailsItem(item);
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      // Cells flow left-to-right, three per row; the order below produces the agreed
      // columnar layout (ids | people & fees | run & dates).
      data: [
        { name: 'PlanningDetailId', label: 'Id' },
        { name: 'ClientOwner', label: 'ClientOwner' },
        { name: 'TpRunDisplayName', label: 'Run' },
        { name: 'FieldworkOrderNumber', label: 'FW Order number' },
        { name: (data) => <UserNameComponent userId={data.SchedulerUserId} />, label: 'Scheduler' },
        { name: 'WaveName', label: 'Wave' },
        { name: 'Status', label: 'Status' },
        { name: 'EvalFeePerEval', label: 'Evaluator Fee' },
        { name: 'StartDate', label: 'FW Period Start' },
        { name: 'ClientName', label: 'Client' },
        { name: 'PricingFieldworkOfficeFeePerEval', label: 'FW Fee' },
        { name: 'EndDate', label: 'FW Period End' },
        { name: 'OpportunityName', label: 'Opportunity' },
        { name: 'EvalBonusPerCycle', label: 'Total Contracted Bonus per Cycle' },
        { name: 'ExtendedEndDate', label: 'Extended End Date' },
        { name: 'OfficeName', label: 'FW Office' },
        { name: 'PricingDetailEditorCostPerEval', label: 'Editor Fee' },
        {
          name: 'CancellationDecision',
          label: 'Cancellation Decision',
          condition: { field: 'Status', value: 'Cancelled' },
        },
        {
          name: 'CancellationComment',
          label: 'Cancellation Comment',
          hidden: (data) => data.Status !== 'Cancelled' || !data.CancellationComment,
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'DetailsResults',
      tabLabel: 'Details & Results',
      icon: 'fa-solid fa-circle-info',
      data: [
        { name: 'NumberOfContractedAssignments', label: 'Contracted Assignments' },
        { name: 'NumberOfPlannedAssignments', label: 'Planned Assignments' },
        { name: 'NumberOfAssignmentsInvoiced', label: 'Invoiced Assignments' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Evaluator Fee' },
        { name: 'TotalContractedEvaluatorFeePlusBonus', label: 'Total Contracted Evaluator Fee Plus Bonus' },
        { name: 'TotalPlannedEvaluatorFeePlusBonus', label: 'Total Planned Evaluator Fee Plus Bonus' },
        { name: 'ActualEvaluatorFee', label: 'Actual Evaluator Fee' },
        {
          name: 'TotalContractedEvaluatorFeePerAssignmentInclBonus',
          label: 'Total Contracted Evaluator Fee Per Assignment Incl Bonus',
        },
        { name: 'TotalPlannedEvaluatorFeePerAssignment', label: 'Total Planned Evaluator Fee Per Assignment' },
        { name: 'ActualEvaluatorFeePerAssignment', label: 'Actual Evaluator Fee Per Assignment' },
        { name: 'PercentageOfContractedEvaluatorFee', label: 'Contracted Evaluator Fee (%)' },
        { name: 'PercentageOfActualEvaluatorFee', label: 'Actual Evaluator Fee (%)' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Owning Office' },
        { name: 'OwningOfficeRevenueContracted', label: 'Contracted Revenue' },
        { name: 'PlannedRevenueOwningOffice', label: 'Planned Revenue' },
        { name: 'InvoicedRevenueOwningOffice', label: 'Invoiced Revenue' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Fieldwork Office' },
        { name: 'FieldworkOfficeRevenueContracted', label: 'Contracted Revenue' },
        { name: 'PlannedRevenueFieldworkOffice', label: 'Planned Revenue' },
        { name: 'InvoicedRevenueFieldworkOffice', label: 'Invoiced Revenue' },

        { name: '-', label: '' },
        { name: '-message-', label: 'Assignments' },
        { name: 'NumberOfAssignmentsAll', label: 'Assigned Assignments' },
        { name: 'NumberOfAssignmentsCompleted', label: 'Completed Assignments' },
        { name: 'NumberOfAssignmentsFinalized', label: 'Finalized Assignments' },
        { name: 'NumberOfAssignmentsExcluded', label: 'Excluded Assignments' },
        { name: 'NumberOfAssignmentsInvoiced', label: 'Invoiced Assignments' },
        { name: 'NumberOfAssignmentsSelfAssigned', label: 'Self Assigned' },
        { name: '', label: '' },
        { name: 'NumberOfAssignmentsExcludedEx', label: 'Excluded Excl.' },
        { name: 'NumberOfAssignmentsExcludedPS', label: 'Excluded PS' },
        { name: 'NumberOfAssignmentsExcludedBC', label: 'Excluded BC' },

        { name: '-', label: '' },
        {
          name: '-message-',
          label: 'The percentages are counted according to the number of the contracted assignments.',
        },

        { name: 'PercentageOfAssignedAssignments', label: 'Assignment %' },
        { name: 'PercentageOfCompletedAssignments', label: 'Completion %' },
        { name: 'PercentageOfFinalizedAssignments', label: 'Finalization %' },
        { name: 'PercentageOfExcludedAssignments', label: 'Excluded %' },
        { name: 'PercentageOfInvoicedAssignments', label: 'Invoiced %' },
        { name: 'PercentageOfSelfAssignedAssignments', label: 'Self Assigned %' },
      ],
    },
    {
      tabName: 'SnapshotHistory',
      tabLabel: 'Snapshot History',
      icon: 'fa-solid fa-clock-rotate-left',
      renderContent: (item) => <PlanningDetailSnapshotInlineSummary planningDetailId={item.PlanningDetailId} />,
    },
  ];

  static NameOfTheIdField() {
    return 'PlanningDetailId';
  }
  static nameOfTheItemDetailList() {
    return 'Planning Details';
  }
  static BoolFields = [];

  //MoneyFields_FieldworkOffice()
  static MoneyFieldsSecondary = [
    'FieldworkOfficeRevenueContracted',
    'PricingFieldworkOfficeFeePerEval',
    'PricingFeePerEval',
    'EvalFeePerEval',
    'PricingDetailEditorCostPerEval',
    'PlannedRevenueFieldworkOffice',
    'InvoicedRevenueFieldworkOffice',
    'EvalBonusPerCycle',
    'TotalContractedFeeAmount',
    'TotalPlannedBonusAmount',
    'PlannedShopperFeePerAssignedAssignments',
    'ActualEvaluatorFee',
    'TotalContractedEvaluatorFeePlusBonus',
    'TotalContractedEvaluatorFeePerAssignmentInclBonus',
    'TotalPlannedEvaluatorFeePlusBonus',
    'TotalPlannedEvaluatorFeePerAssignment',
    'ActualEvaluatorFee',
    'ActualEvaluatorFeePerAssignment',
  ];

  static CurrencySecondary() {
    return 'FieldworkOfficeCurrency';
  }

  // MoneyFields_OwningOffice
  static MoneyFields = [
    'OwningOfficeRevenueContracted',
    'PricingOwningOfficeFeePerEval',
    'PlannedRevenueOwningOffice',
    'InvoicedRevenueOwningOffice',
  ];

  static Currency() {
    return 'OwningOfficeCurrency';
  }

  static clickOnSelect(item, indexOfItem) {}

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={() => PlanningDetailsItem.clickOnSelect(item)}
      />
    );
  }

  static getPlannedCellContent(item) {
    return <PlannedCell item={item} />;
  }

  static getContractedCellContent(item) {
    const isOverridden = item.NumberOfContractedAssignments !== item.NumberOfContractedAssignmentsOriginal;
    return (
      <span>
        {item.NumberOfContractedAssignments}
        {isOverridden && (
          <i
            className='fa-solid fa-pen text-warning ms-1'
            style={{ fontSize: '0.75em' }}
            title={`Overridden (original: ${item.NumberOfContractedAssignmentsOriginal})`}
          />
        )}
      </span>
    );
  }

  static getStatusCellContent(item) {
    return (
      <span>
        {statusHelper.getStatusColorIcon(item.Status)}
        {stringHelper.convertToWords(item.Status)}
        {PlanningDetailsItem.getReplacedByContent(item)}
      </span>
    );
  }

  // A Replaced period belongs to a pricing that a newer approved pricing superseded. Say which one, and take
  // the user straight to that pricing's planning - that is where the work continues.
  static getReplacedByContent(item) {
    if (item.Status !== PlanningStatusEnum.Replaced || !item.ReplacedByPricingId) {
      return null;
    }
    return (
      <span className='pl-1 text-muted'>
        (by{' '}
        <Link
          linktext={`Pricing #${item.ReplacedByPricingId}`}
          title='Planning - Planning Details'
          link={<PlanningDetailList pricingId={item.ReplacedByPricingId} />}
          url={`planning_PlanningDetailList/search?ServiceId=${item.ServiceId}&PricingId=${item.ReplacedByPricingId}`}
        />
        )
      </span>
    );
  }

  static renderDateWithLock(dateValue, isLocked) {
    return (
      <span>
        {dateTimeHelper.toYYYYsMMsDDWithIndefinite(dateValue)}
        {isLocked && (
          <i
            className='fa-solid fa-lock text-muted ms-1'
            title='Dates are locked'
          />
        )}
      </span>
    );
  }

  static getStartDateCellContent(item) {
    return PlanningDetailsItem.renderDateWithLock(item.StartDate, item.IsDateLocked);
  }

  static getEndDateCellContent(item) {
    return PlanningDetailsItem.renderDateWithLock(item.EndDate, item.IsDateLocked);
  }

  static clickOnLink = (id, panelEnumId) => {
    alert('Empty function');
  };

  static renderLink(id, panelEnumId, text) {
    return (
      <span
        className='link  p-1'
        onClick={() => PlanningDetailsItem.clickOnLink(id, panelEnumId)}
      >
        {`${text}   `}
      </span>
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            disabled: item.Status === PlanningStatusEnum.Closed || item.Status === PlanningStatusEnum.Cancelled,
            onClick: () => PlanningDetailsItem.clickOnLink(item, ShownSubPanelsEnum.EditItem),
          },
          {
            iconName: 'fa-solid fa-step-forward',
            text: 'Update',
            disabled: !(PlanningStatusEnum.Closed || userHelper.isAdmin()),
            onClick: () => PlanningDetailsItem.clickOnLink(item, ShownSubPanelsEnum.StatusUpdate),
          },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Id', data: 'PlanningDetailId', type: FieldTypesEnum.DataFieldWithDetails },
      { label: PlanningDetailsItem.getSelectedCellHeader, data: PlanningDetailsItem.getSelectedCellContent },
      { label: 'Field Work', data: 'FieldworkOfficeRevenueContracted' },
      { label: 'Start Date', data: PlanningDetailsItem.getStartDateCellContent },
      { label: 'End Date', data: PlanningDetailsItem.getEndDateCellContent },
      { label: 'Contracted', data: PlanningDetailsItem.getContractedCellContent },
      { label: 'Planned', data: PlanningDetailsItem.getPlannedCellContent },
      // How the period is actually going, in the same order the work moves through. Without
      // these the grid stops at what was promised, and the only way to see what happened was
      // to open every row in turn.
      { label: 'Assigned', data: 'NumberOfAssignmentsAll', className: 'text-right pr-1', minWidth: 50 },
      { label: 'Completed', data: 'NumberOfAssignmentsCompleted', className: 'text-right pr-1', minWidth: 50 },
      { label: 'Finalized', data: 'NumberOfAssignmentsFinalized', className: 'text-right pr-1', minWidth: 50 },
      { label: 'Invoiced', data: 'NumberOfAssignmentsInvoiced', className: 'text-right pr-1', minWidth: 50 },
      { label: 'Graph', data: (item) => <PlanningProgressGraph item={item} /> },
      { label: 'Status', data: PlanningDetailsItem.getStatusCellContent },
      { label: ' ', data: PlanningDetailsItem.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getSelectedCellHeader() {
    return (
      <input
        type='checkbox'
        checked={PlanningDetailsItem.selectedStatus()}
        onChange={(e) => {
          PlanningDetailsItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static selectedStatus() {
    //Placeholder function
  }

  static clickOnGlobalSelect(item, checked) {
    //Placeholder  function
  }
}
